import React from "react";
import Book from "@components/Book";
import BookVideo from "@components/BookVideo";

const BookVideoWrapContainer = ({ type, data, onSwap }) => {
  return type === "book" ? (
    <Book data={data} onSwap={onSwap} />
  ) : (
    <BookVideo data={data} onSwap={onSwap} />
  );
};

export default React.memo(BookVideoWrapContainer);
